// extracted by mini-css-extract-plugin
export default {"root":"IconVerifiedCheck_root__07kPR"};